import { combineReducers } from '@reduxjs/toolkit';

import coreReducer from './core';
import productsReducer from './products';
import layoutReducer from './layout';
import roomSizeHistoryReducer from './roomSizeHistory';
import assemblyInstructionsReducer from './assemblyInstructions';
import selectionOverrideReducer from './selectionOverride';
import vpcReducer from './vpc';
import mobileReducer from './mobile';
import sheetsReducer from './sheets';
import questionSheetReducer from './questionSheet';
import changeFrontsReducer from './changeFronts';
import helpLinesReducer from './helpLines';
import moveButtonsMenuReducer from './moveButtonsMenu';
import rangeReducer from './range';
import userInfoReducer from './userInfo';
import { RootState } from 'ducks';
import designIdReducer from './designId';

export const staticReducers = {
  core: coreReducer,
  products: productsReducer,
  layout: layoutReducer,
  roomSizeHistory: roomSizeHistoryReducer,
  assemblyInstructions: assemblyInstructionsReducer,
  vpc: vpcReducer,
  designId: designIdReducer,
  selectionOverride: selectionOverrideReducer,
  mobile: mobileReducer,
  sheets: sheetsReducer,
  questionSheet: questionSheetReducer,
  changeFronts: changeFrontsReducer,
  helpLines: helpLinesReducer,
  moveButtonsMenu: moveButtonsMenuReducer,
  range: rangeReducer,
  userInfo: userInfoReducer
};

const rootReducer = combineReducers(staticReducers);

export const getRootState = (state: RootState) => state;

export default rootReducer;
